import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "148.265",
  height: "148.265"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("g", {
      "data-name": "Group 3653",
      opacity: ".02"
    }, [
      _createElementVNode("g", { "data-name": "Group 3652" }, [
        _createElementVNode("path", {
          fill: "#1a1818",
          d: "M45.854 122.612h34.338V32.724C68.881 40.2 57.368 44.641 45.854 47.873V20.6C61.608 15.958 75.142 9.292 85.848 0h28.482v122.612h33.936v25.653H45.854Z",
          "data-name": "Path 1809"
        })
      ])
    ], -1)
  ])))
}
export default { render: render }